<script setup>
import { computed } from 'vue';
import CifraInputField from '../inputs/CifraInputField.vue';

/**
 * Checkbox booleano con la misma estética que ui_checkbox / ui_checkbox_boolean.
 * - modelValue: true/false, indica si está marcado.
 * - value: atributo HTML del input para envío de formularios (p. ej. un id).
 */
const modelValue = defineModel({ type: Boolean, default: false });

const props = defineProps({
  name: { type: String, default: null },
  value: { type: [String, Boolean, Number], default: null },
  disabled: { type: Boolean, default: false },
  inputId: { type: String, default: null },
  tipo: {
    type: String,
    default: 'checkbox',
    validator: (v) => ['checkbox', 'switch'].includes(v),
  },
  error: { type: [String, Array], default: null },
});

const esSwitch = computed(() => props.tipo === 'switch');
</script>

<template>
  <CifraInputField v-model="modelValue" :error="error">
    <label
      class="cifra-checkbox"
      :class="{ 'cifra-switch': esSwitch, disabled }"
    >
      <input
        :id="inputId"
        type="checkbox"
        :name="name"
        :value="value"
        :checked="modelValue"
        :disabled="disabled"
        @change="modelValue = $event.target.checked"
      />
      <span v-if="!esSwitch" class="check-icon">
        <i class="fas fa-check-square"></i>
        <i class="far fa-square"></i>
      </span>
      <span v-else class="switch-track">
        <span class="switch-knob"></span>
      </span>
      <span v-if="$slots.default" class="check-label">
        <slot></slot>
      </span>
    </label>
  </CifraInputField>
</template>

<style lang="scss">
@import '../../../assets/stylesheets/cifra/checkbox';
</style>
